<template>
  <div></div>
</template>
<script>
import jtCard from "@/components/Card";
export default {
  components: {},
};
</script>
